import { z } from "zod";
import { generationPreferencesSchema } from "./model-preferences";

export const CREATION_DRAFT_MAX_BYTES = 200 * 1024;
export const CREATION_DRAFT_TTL_MS = 24 * 60 * 60 * 1000;

export const creationDraftInputSchema = z.object({
  objective: z.string().min(1).refine((value) => value.trim().length > 0),
  sourceNames: z.array(z.string().min(1).max(1024)).max(3),
  mode: z.enum(["fast", "professional", "creative"]),
  preferences: generationPreferencesSchema,
}).strict();

export const creationDraftSchema = z.object({
  version: z.literal(1),
  id: z.string().uuid(),
  createdAt: z.number().int().nonnegative(),
  input: creationDraftInputSchema,
}).strict();

export type CreationDraftInput = z.infer<typeof creationDraftInputSchema>;
export type CreationDraft = z.infer<typeof creationDraftSchema>;
